import { useState, useEffect, useCallback } from 'react';
import { Interview } from '@recruitai/shared';
import { apiClient } from '../lib/api-client';

interface UseInterviewResult {
  interview: Interview | null;
  isLoading: boolean;
  error: Error | null;
  refetch: () => Promise<void>;
}

export function useInterview(
  jobId: string,
  candidateId: string,
  interviewId: string
): UseInterviewResult {
  const [interview, setInterview] = useState<Interview | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const fetchInterview = useCallback(async () => {
    if (!jobId || !candidateId || !interviewId) {
      setIsLoading(false);
      return;
    }
    try {
      setIsLoading(true);
      setError(null);
      const response = await apiClient.get<{ interview: Interview }>(
        `/jobs/${jobId}/candidates/${candidateId}/interviews/${interviewId}`
      );
      setInterview(response.interview);
    } catch (err) {
      setError(err instanceof Error ? err : new Error('Falha ao carregar entrevista'));
    } finally {
      setIsLoading(false);
    }
  }, [jobId, candidateId, interviewId]);

  useEffect(() => {
    fetchInterview();
  }, [fetchInterview]);

  return { interview, isLoading, error, refetch: fetchInterview };
}
